"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = VideoIcon;
var _react = _interopRequireDefault(require("react"));
var _iconBase = _interopRequireDefault(require("./shared/icon-base"));
var _core = require("@emotion/core");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function VideoIcon(props) {
  return (0, _core.jsx)(_iconBase.default, props, (0, _core.jsx)("path", {
    d: "M1 3V21H23V3H1ZM21 19H3V5H21V19ZM8 6.45117V17.5488L17.1553 12L8 6.45117ZM10 10.002L13.2969 12L10 13.998V10.002V10.002Z",
    fill: "currentColor"
  }));
}